import Pluralize from "react-pluralize";
import DatePicker from "@shared/v2/DatePicker";
import { Button, Col, Modal, Row } from "../../shared/v1";

const RescheduleModal = ({
  showRescheduleModal,
  closeRescheduleModalHandler,
  selectedTasks,
  rescheduleDate,
  rescheduleDateHandler,
  rescheduleTasksHandler,
}) => (
  <Modal size="small" show={showRescheduleModal} onHide={closeRescheduleModalHandler}>
    <Modal.Header closeButton>
      <Modal.Title>
        Hey! You're about to reschedule <Pluralize singular="task" count={selectedTasks.length} /> tasks!
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <Row>
        <Col size={12}>
          <p>
            Don't worry, your client doesn't see when you reschedule something. Select how far you want to
            move these dates around.
          </p>
        </Col>
      </Row>
      <Row>
        <Col size={6}>
          <DatePicker
            position="bottom-left"
            inputProps={{ name: "reschedule_date" }}
            value={rescheduleDate || ""}
            onChange={(value) => value && rescheduleDateHandler(value)}
          />
        </Col>
      </Row>
    </Modal.Body>
    <Modal.Footer>
      <Button size="small" className="modal-cancel tw-float-left" onClick={closeRescheduleModalHandler}>
        Cancel
      </Button>
      <Button size="small" className="modal-submit tw-float-right" onClick={rescheduleTasksHandler}>
        Reschedule
      </Button>
    </Modal.Footer>
  </Modal>
);

export default RescheduleModal;
